import * as types from "../constants/actionTypes";

import {addNotification as notify} from 'reapop';
import * as portActions from "../graphql/actions/port";
import l10n from "../l10n/localization";
import * as creationActions from "./creation";
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as authHandler from "../utils/authHandler";

export function fetchPorts(force = false) {
	return dispatch => {
		dispatch(loading());
        portActions.getPorts(
			function(response) {
				dispatch(receivePorts(response.data.ports));
			},
			function(error) {
				dispatch(notify({message: error.message, status: 'error'}));
			},
			force
		);
	}
}

export function add(port) {
    return dispatch => {
        dispatch(loading());
        dispatch(saving(port));
        portActions.add(
            function (response) {
                dispatch(saved(response.data.createPort));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedPort(response.data.createPort));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            port
        );
    };
}


export function edit(port) {
    let id = port.id;
    delete port.id;
    delete port.__typename;
    delete port.countryName;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(port));
        portActions.edit(
            function (response) {
                dispatch(saved(response.data.editPort));
                dispatch(fetchPorts(true));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            port
        );
    };
}

export function deletePort(portID) {
    return dispatch => {
        let url = ajaxRoutes.API_ROUTE + "/port/delete/"+portID;
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});
        dispatch(deletingPort());
        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                dispatch(notify({message: l10n.messages.removed, status: 'success'}));
                return response;
            })
            .then(() => {
                dispatch(doneDeletingPort());
                dispatch(fetchPorts(true));
            })
            .catch((error) => {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(doneDeletingPort());
            });
    };
}

export function deletingPort() {
    return {
        type: types.DELETING_PORT
    };
}

export function doneDeletingPort () {
    return {
        type: types.DONE_DELETING_PORT
    };
}


export function loading() {
    return {
        type: types.LOADING_PORT
    };
}


export function saving(port) {
    return {
        type: types.SAVING_PORT,
        payload: port
    };
}

export function saved(port) {
    return {
        type: types.SAVED_PORT,
        payload: port
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_PORTS,
    };
}

export function receivePorts(data) {
    return {
        type: types.RECEIVED_PORTS,
        payload: data
    };
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}



// WEBPACK FOOTER //
// ./src/actions/port.js